/// <amd-module name="Dashboards/DashboardView/src/redux/RootProviderProps" />
import { IModule } from "redux-dynamic-modules";

import { DashboardViewAwareState } from "../model/DashboardViewState";
import { FeatureArea, TTISplitTimingName } from "./actions/TelemetryActions";
import { dashboardViewModule } from "./Module";
import { DashboardViewSagaContext } from "./sagas/SagaContext";

import { getTfsPageDataModule } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule";

import { IVssPageContext } from "VSS/Platform/Context";
import { IRootProviderProps } from "VSS/Redux/Deprecated/RootProvider";

import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";

export namespace DashboardViewRootProviderProps {
    export function get(pageContext: IVssPageContext): IRootProviderProps<DashboardViewSagaContext, DashboardViewAwareState> {
        const hubViewState = new VssHubViewState(pageContext);
        const sagaContext: DashboardViewSagaContext = {
            pageContext,
            dashboardViewContext: {}
        };

        // We set our module as the last in the array to ensure our module dependencies run their main sagas first
        const modules: IModule<any>[] = [getTfsPageDataModule(), dashboardViewModule];

        return {
            initialState: {},
            hubViewState,
            sagaContext,
            modules,
            scenarioName: FeatureArea,
            ttiSplitTimingName: TTISplitTimingName
        };
    }
}
